export const IsAdmin = (user) => {
   const approvedAdminSubs = process.env.REACT_APP_ADMIN_SUBS.split(',');
   const isApprovedAdmin = user && user.sub && approvedAdminSubs.includes(user.sub);
   return isApprovedAdmin;
};
